const DEFAULT_WAIT_TIME = 333

export default function createDefaultWait(ms = DEFAULT_WAIT_TIME) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
